var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _ellipse5, _ellipse6, _ellipse7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10752_2244)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10752_2244)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "#601F93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 200.982C21.3922 203.408 21.7315 234.806 18 252.625V269.542L233.746 278L237.477 155.861C244.601 118.644 176.982 98.4061 151.315 122.365C124.855 147.064 129.265 197.937 69.2227 200.982Z",
    fill: "#6A48B3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.706 210.383H117.611V221.946H127.706V210.383Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.706 212.812H117.611V216.434H127.706V212.812Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.859 156.094H87.4579C85.3523 156.094 83.6454 157.79 83.6454 159.883V208.926C83.6454 211.018 85.3523 212.715 87.4579 212.715H157.859C159.965 212.715 161.672 211.018 161.672 208.926V159.883C161.672 157.79 159.965 156.094 157.859 156.094Z",
    fill: "url(#paint0_linear_10752_2244)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6454 205.869V209.076C83.6454 211.266 85.3517 213.051 87.4578 213.051H157.859C159.965 213.051 161.672 211.275 161.672 209.076V205.869H83.6454Z",
    fill: "url(#paint1_linear_10752_2244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.428 157.252H88.8975C86.8803 157.252 85.245 158.877 85.245 160.882V200.12C85.245 202.125 86.8803 203.75 88.8975 203.75H156.428C158.446 203.75 160.081 202.125 160.081 200.12V160.882C160.081 158.877 158.446 157.252 156.428 157.252Z",
    fill: "url(#paint2_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.015 159.343C156.375 158.672 155.469 158.248 154.464 158.248H89.7417C87.8044 158.248 86.2403 159.803 86.2403 161.728V199.34C86.2403 200.135 86.5069 200.877 86.969 201.46L157.015 159.343Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.626 220.285H134.691C135.687 220.285 136.495 221.089 136.495 222.078V224.605H108.813V222.078C108.813 221.089 109.622 220.285 110.617 220.285H110.626Z",
    fill: "url(#paint3_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.691 220.285H122.756C123.752 220.285 124.56 221.089 124.56 222.078V224.605H136.495V222.078C136.495 221.089 135.687 220.285 134.691 220.285Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.673 221.469C117.673 222.061 114.403 222.185 112.065 222.185C109.995 222.185 109.666 221.867 109.666 221.469C109.666 221.072 110.137 220.754 112.065 220.754C114.403 220.754 117.673 220.886 117.673 221.469Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 221.469C120.179 221.707 119.717 221.875 119.211 221.875C118.704 221.875 118.349 221.69 118.349 221.469C118.349 221.248 118.704 221.062 119.211 221.062C119.717 221.062 120.179 221.23 120.179 221.469Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.504 223.811H108.822V224.606H136.504V223.811Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.672 205.869H83.6454V206.903H161.672V205.869Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.157 209.624C157.157 210.436 156.491 211.099 155.673 211.099C154.855 211.099 154.189 210.436 154.189 209.624C154.189 208.811 154.855 208.148 155.673 208.148C156.491 208.148 157.157 208.811 157.157 209.624Z",
    fill: "#463332"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.66 209.624C156.66 210.163 156.224 210.596 155.682 210.596C155.14 210.596 154.704 210.163 154.704 209.624C154.704 209.085 155.14 208.652 155.682 208.652C156.224 208.652 156.66 209.085 156.66 209.624Z",
    fill: "url(#paint4_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.761 160.77H125.844V201.888H156.761V160.77Z",
    fill: "#6D4791"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.761 159.188H125.844V200.306H156.761V159.188Z",
    fill: "#FFF4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.69 161.008H127.896V164.974H154.69V161.008Z",
    fill: "url(#paint5_linear_10752_2244)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.351 164.265V161.898H133.636V164.039H134.743V164.265H133.351Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.135 164.265V161.898H136.606V162.131H135.421V162.956H136.504V163.186H135.421V164.032H136.606V164.265H135.135Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.81 164.306C137.635 164.306 137.484 164.274 137.355 164.211C137.225 164.148 137.126 164.06 137.056 163.947C136.985 163.835 136.95 163.704 136.95 163.555H137.249C137.249 163.647 137.271 163.733 137.314 163.812C137.357 163.889 137.419 163.951 137.501 163.998C137.584 164.043 137.687 164.066 137.81 164.066C137.97 164.066 138.095 164.027 138.183 163.951C138.271 163.874 138.316 163.778 138.316 163.663C138.316 163.569 138.295 163.493 138.255 163.437C138.214 163.378 138.158 163.331 138.088 163.295C138.02 163.259 137.941 163.227 137.85 163.2C137.762 163.173 137.669 163.142 137.572 163.109C137.388 163.045 137.253 162.968 137.164 162.875C137.076 162.781 137.032 162.658 137.032 162.507C137.03 162.38 137.059 162.269 137.12 162.172C137.181 162.073 137.267 161.996 137.378 161.942C137.492 161.886 137.625 161.857 137.779 161.857C137.931 161.857 138.062 161.886 138.173 161.942C138.286 161.998 138.373 162.076 138.434 162.175C138.498 162.274 138.531 162.387 138.533 162.513H138.234C138.234 162.448 138.217 162.384 138.183 162.321C138.149 162.255 138.097 162.202 138.027 162.162C137.959 162.121 137.873 162.101 137.769 162.101C137.64 162.099 137.533 162.131 137.45 162.199C137.368 162.267 137.327 162.36 137.327 162.48C137.327 162.581 137.356 162.659 137.412 162.713C137.471 162.767 137.553 162.812 137.657 162.848C137.761 162.882 137.881 162.921 138.017 162.967C138.13 163.007 138.232 163.055 138.322 163.109C138.413 163.163 138.483 163.233 138.533 163.318C138.585 163.404 138.611 163.513 138.611 163.646C138.611 163.759 138.582 163.866 138.523 163.968C138.464 164.067 138.374 164.148 138.255 164.211C138.137 164.274 137.988 164.306 137.81 164.306Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.773 164.306C139.599 164.306 139.447 164.274 139.318 164.211C139.189 164.148 139.089 164.06 139.019 163.947C138.949 163.835 138.914 163.704 138.914 163.555H139.213C139.213 163.647 139.234 163.733 139.277 163.812C139.32 163.889 139.382 163.951 139.464 163.998C139.548 164.043 139.651 164.066 139.773 164.066C139.934 164.066 140.058 164.027 140.147 163.951C140.235 163.874 140.279 163.778 140.279 163.663C140.279 163.569 140.259 163.493 140.218 163.437C140.177 163.378 140.122 163.331 140.051 163.295C139.984 163.259 139.904 163.227 139.814 163.2C139.725 163.173 139.633 163.142 139.535 163.109C139.352 163.045 139.216 162.968 139.128 162.875C139.039 162.781 138.995 162.658 138.995 162.507C138.993 162.38 139.022 162.269 139.084 162.172C139.145 162.073 139.231 161.996 139.342 161.942C139.455 161.886 139.588 161.857 139.742 161.857C139.894 161.857 140.025 161.886 140.136 161.942C140.25 161.998 140.337 162.076 140.398 162.175C140.461 162.274 140.494 162.387 140.496 162.513H140.198C140.198 162.448 140.181 162.384 140.147 162.321C140.113 162.255 140.061 162.202 139.99 162.162C139.922 162.121 139.836 162.101 139.732 162.101C139.603 162.099 139.497 162.131 139.413 162.199C139.331 162.267 139.291 162.36 139.291 162.48C139.291 162.581 139.319 162.659 139.376 162.713C139.435 162.767 139.516 162.812 139.62 162.848C139.724 162.882 139.844 162.921 139.98 162.967C140.093 163.007 140.195 163.055 140.286 163.109C140.376 163.163 140.447 163.233 140.496 163.318C140.548 163.404 140.574 163.513 140.574 163.646C140.574 163.759 140.545 163.866 140.486 163.968C140.427 164.067 140.338 164.148 140.218 164.211C140.1 164.274 139.952 164.306 139.773 164.306Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.059 164.306C141.826 164.306 141.621 164.255 141.444 164.154C141.27 164.05 141.133 163.906 141.033 163.721C140.936 163.536 140.887 163.323 140.887 163.082C140.887 162.84 140.936 162.628 141.033 162.446C141.133 162.261 141.27 162.117 141.444 162.013C141.621 161.909 141.826 161.857 142.059 161.857C142.294 161.857 142.499 161.909 142.674 162.013C142.85 162.117 142.987 162.261 143.085 162.446C143.182 162.628 143.231 162.84 143.231 163.082C143.231 163.323 143.182 163.536 143.085 163.721C142.987 163.906 142.85 164.05 142.674 164.154C142.499 164.255 142.294 164.306 142.059 164.306ZM142.059 164.055C142.233 164.055 142.386 164.017 142.517 163.94C142.651 163.862 142.754 163.75 142.827 163.606C142.901 163.459 142.939 163.284 142.939 163.082C142.939 162.879 142.901 162.705 142.827 162.561C142.754 162.417 142.651 162.306 142.517 162.229C142.386 162.15 142.233 162.111 142.059 162.111C141.885 162.111 141.731 162.15 141.597 162.229C141.466 162.306 141.363 162.417 141.288 162.561C141.216 162.705 141.179 162.879 141.179 163.082C141.179 163.284 141.216 163.459 141.288 163.606C141.363 163.75 141.466 163.862 141.597 163.94C141.731 164.017 141.885 164.055 142.059 164.055Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.642 164.265V161.898H143.927L145.194 163.795V161.898H145.479V164.265H145.194L143.927 162.368V164.265H143.642Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.117 164.265V162.216L146.733 162.3V162.104L147.212 161.898H147.405V164.265H147.117Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.87 164.265V164.066C148.031 163.939 148.182 163.812 148.325 163.683C148.47 163.553 148.598 163.424 148.709 163.298C148.822 163.172 148.91 163.048 148.974 162.926C149.039 162.804 149.072 162.687 149.072 162.574C149.072 162.491 149.057 162.413 149.028 162.341C149.001 162.269 148.955 162.211 148.892 162.169C148.829 162.123 148.743 162.101 148.634 162.101C148.53 162.101 148.443 162.125 148.372 162.172C148.302 162.217 148.249 162.278 148.213 162.355C148.179 162.431 148.162 162.513 148.162 162.601H147.887C147.887 162.446 147.92 162.313 147.985 162.202C148.051 162.09 148.14 162.004 148.254 161.945C148.367 161.887 148.495 161.857 148.637 161.857C148.848 161.857 149.02 161.917 149.154 162.037C149.289 162.154 149.357 162.33 149.357 162.564C149.357 162.704 149.322 162.843 149.252 162.98C149.182 163.115 149.092 163.247 148.984 163.376C148.875 163.502 148.759 163.62 148.634 163.731C148.512 163.841 148.397 163.94 148.291 164.028H149.439V164.265H147.87Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 167.801L139.644 167.197H133.351L133.358 167.801H139.651Z",
    fill: "#DDC8BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 167.801L154.252 167.197H140.383L140.397 167.801H154.266Z",
    fill: "#DDC8BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 170.636L139.644 170.033H133.351L133.358 170.636H139.651Z",
    fill: "#DDC8BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 170.636L154.252 170.033H140.383L140.397 170.636H154.266Z",
    fill: "#DDC8BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 169.217V168.613H147.045L147.059 169.217H154.266Z",
    fill: "#DDC8BA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 169.217V168.613H133.351L133.365 169.217H146.424Z",
    fill: "#DDC8BA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 172.064L136.944 171.461H133.351L133.358 172.064H136.951Z",
    fill: "#DDC8BA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 172.037L146.09 171.434H137.69L137.697 172.037H146.104Z",
    fill: "#DDC8BA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 174.742L139.644 174.139H133.351L133.358 174.742H139.651Z",
    fill: "#DDC8BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 174.742L154.252 174.139H140.383L140.397 174.742H154.266Z",
    fill: "#DDC8BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 177.578L139.644 176.975H133.351L133.358 177.578H139.651Z",
    fill: "#DDC8BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 177.578L154.252 176.975H140.383L140.397 177.578H154.266Z",
    fill: "#DDC8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 176.156V175.553H147.045L147.059 176.156H154.266Z",
    fill: "#DDC8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 176.156V175.553H133.351L133.365 176.156H146.424Z",
    fill: "#DDC8BA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 179.006L136.944 178.402H133.351L133.358 179.006H136.951Z",
    fill: "#DDC8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 178.978L146.09 178.375H137.69L137.697 178.978H146.104Z",
    fill: "#DDC8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 181.683L139.644 181.08H133.351L133.358 181.683H139.651Z",
    fill: "#DDC8BA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 181.683L154.252 181.08H140.383L140.397 181.683H154.266Z",
    fill: "#DDC8BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 184.519L139.644 183.916H133.351L133.358 184.519H139.651Z",
    fill: "#DDC8BA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 184.519L154.252 183.916H140.383L140.397 184.519H154.266Z",
    fill: "#DDC8BA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 183.097V182.494H147.045L147.059 183.097H154.266Z",
    fill: "#DDC8BA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 183.097V182.494H133.351L133.365 183.097H146.424Z",
    fill: "#DDC8BA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 185.947L136.944 185.344H133.351L133.358 185.947H136.951Z",
    fill: "#DDC8BA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 185.92L146.09 185.316H137.69L137.697 185.92H146.104Z",
    fill: "#DDC8BA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 188.625L139.644 188.021H133.351L133.358 188.625H139.651Z",
    fill: "#DDC8BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 188.625L154.252 188.021H140.383L140.397 188.625H154.266Z",
    fill: "#DDC8BA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 191.461L139.644 190.857H133.351L133.358 191.461H139.651Z",
    fill: "#DDC8BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 191.461L154.252 190.857H140.383L140.397 191.461H154.266Z",
    fill: "#DDC8BA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 190.039V189.436H147.045L147.059 190.039H154.266Z",
    fill: "#DDC8BA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 190.039V189.436H133.351L133.365 190.039H146.424Z",
    fill: "#DDC8BA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136.951 192.888L136.944 192.285H133.351L133.358 192.888H136.951Z",
    fill: "#DDC8BA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 192.861L146.09 192.258H137.69L137.697 192.861H146.104Z",
    fill: "#DDC8BA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 194.5L139.644 193.896H133.351L133.358 194.5H139.651Z",
    fill: "#DDC8BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 194.5L154.252 193.896H140.383L140.397 194.5H154.266Z",
    fill: "#DDC8BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M139.651 197.336L139.644 196.732H133.351L133.358 197.336H139.651Z",
    fill: "#DDC8BA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 197.336L154.252 196.732H140.383L140.397 197.336H154.266Z",
    fill: "#DDC8BA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M154.266 195.916V195.312H147.045L147.059 195.916H154.266Z",
    fill: "#DDC8BA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.424 195.916V195.312H133.351L133.365 195.916H146.424Z",
    fill: "#DDC8BA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 168.799,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint6_linear_10752_2244)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 175.741,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint7_linear_10752_2244)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 182.682,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint8_linear_10752_2244)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.134,
    cy: 189.623,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint9_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M121.904 160.979H90.9865V202.097H121.904V160.979Z",
    fill: "#6D4791"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M121.904 159.398H90.9866V200.517H121.904V159.398Z",
    fill: "#FFF4EE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 167.802L104.786 167.199H98.494L98.501 167.802H104.793Z",
    fill: "#DDC8BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 167.802L119.394 167.199H105.526L105.54 167.802H119.408Z",
    fill: "#DDC8BA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 170.638L104.786 170.035H98.494L98.501 170.638H104.793Z",
    fill: "#DDC8BA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 170.638L119.394 170.035H105.526L105.54 170.638H119.408Z",
    fill: "#DDC8BA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 169.217V168.613H112.188L112.202 169.217H119.408Z",
    fill: "#DDC8BA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 169.217V168.613H98.494L98.508 169.217H111.567Z",
    fill: "#DDC8BA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 172.068L102.087 171.465H98.494L98.501 172.068H102.094Z",
    fill: "#DDC8BA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 172.039L111.232 171.436H102.833L102.84 172.039H111.246Z",
    fill: "#DDC8BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 174.744L104.786 174.141H98.494L98.501 174.744H104.793Z",
    fill: "#DDC8BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 174.744L119.394 174.141H105.526L105.54 174.744H119.408Z",
    fill: "#DDC8BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 177.58L104.786 176.977H98.494L98.501 177.58H104.793Z",
    fill: "#DDC8BA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 177.58L119.394 176.977H105.526L105.54 177.58H119.408Z",
    fill: "#DDC8BA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 176.158V175.555H112.188L112.202 176.158H119.408Z",
    fill: "#DDC8BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 176.158V175.555H98.494L98.508 176.158H111.567Z",
    fill: "#DDC8BA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 179.008L102.087 178.404H98.494L98.501 179.008H102.094Z",
    fill: "#DDC8BA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 178.98L111.232 178.377H102.833L102.84 178.98H111.246Z",
    fill: "#DDC8BA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 181.685L104.786 181.082H98.494L98.501 181.685H104.793Z",
    fill: "#DDC8BA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 181.685L119.394 181.082H105.526L105.54 181.685H119.408Z",
    fill: "#DDC8BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 184.521L104.786 183.918H98.494L98.501 184.521H104.793Z",
    fill: "#DDC8BA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 184.521L119.394 183.918H105.526L105.54 184.521H119.408Z",
    fill: "#DDC8BA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M119.408 183.099V182.496H112.188L112.202 183.099H119.408Z",
    fill: "#DDC8BA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 183.099V182.496H98.494L98.508 183.099H111.567Z",
    fill: "#DDC8BA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 185.951L102.087 185.348H98.494L98.501 185.951H102.094Z",
    fill: "#DDC8BA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M111.246 185.922L111.232 185.318H102.833L102.84 185.922H111.246Z",
    fill: "#DDC8BA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 189.909L101.147 189.141H93.1314L93.1403 189.909H101.156Z",
    fill: "#DDC8BA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 189.909L119.756 189.141H102.089L102.107 189.909H119.774Z",
    fill: "#DDC8BA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 188.257V187.488H110.576L110.594 188.257H119.774Z",
    fill: "#DDC8BA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M109.785 188.257V187.488H93.1314L93.1492 188.257H109.785Z",
    fill: "#DDC8BA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M97.717 191.577L97.7081 190.809H93.1314L93.1403 191.577H97.717Z",
    fill: "#DDC8BA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M109.376 191.542L109.359 190.773H98.659L98.6679 191.542H109.376Z",
    fill: "#DDC8BA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.833 161.219H93.0393V165.185H119.833V161.219Z",
    fill: "url(#paint10_linear_10752_2244)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M98.494 164.485V161.904H98.7984V164.238H99.9796V164.485H98.494Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M100.398 164.485V161.904H101.967V162.158H100.702V163.058H101.858V163.309H100.702V164.231H101.967V164.485H100.398Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M103.251 164.529C103.065 164.529 102.903 164.495 102.765 164.426C102.628 164.357 102.521 164.261 102.446 164.138C102.372 164.015 102.334 163.873 102.334 163.711H102.653C102.653 163.811 102.676 163.905 102.722 163.991C102.768 164.074 102.834 164.142 102.921 164.194C103.01 164.243 103.12 164.267 103.251 164.267C103.422 164.267 103.555 164.226 103.649 164.142C103.744 164.058 103.791 163.954 103.791 163.829C103.791 163.725 103.769 163.643 103.725 163.581C103.682 163.518 103.623 163.466 103.548 163.427C103.475 163.387 103.391 163.353 103.294 163.323C103.2 163.294 103.101 163.261 102.997 163.224C102.802 163.155 102.657 163.07 102.562 162.969C102.468 162.866 102.421 162.732 102.421 162.567C102.419 162.43 102.45 162.308 102.515 162.202C102.581 162.094 102.672 162.011 102.791 161.952C102.911 161.89 103.054 161.859 103.218 161.859C103.38 161.859 103.52 161.89 103.639 161.952C103.759 162.013 103.852 162.098 103.918 162.206C103.985 162.314 104.02 162.437 104.023 162.575H103.704C103.704 162.503 103.686 162.433 103.649 162.365C103.613 162.293 103.558 162.236 103.483 162.191C103.41 162.147 103.318 162.125 103.207 162.125C103.07 162.122 102.956 162.158 102.867 162.232C102.78 162.306 102.736 162.408 102.736 162.538C102.736 162.649 102.767 162.733 102.827 162.792C102.89 162.851 102.977 162.901 103.088 162.94C103.199 162.977 103.327 163.02 103.472 163.069C103.593 163.113 103.701 163.165 103.798 163.224C103.895 163.283 103.969 163.359 104.023 163.452C104.078 163.546 104.106 163.665 104.106 163.81C104.106 163.933 104.075 164.05 104.012 164.16C103.949 164.269 103.853 164.357 103.725 164.426C103.6 164.495 103.442 164.529 103.251 164.529Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 164.529C105.16 164.529 104.998 164.495 104.86 164.426C104.722 164.357 104.616 164.261 104.541 164.138C104.466 164.015 104.429 163.873 104.429 163.711H104.748C104.748 163.811 104.771 163.905 104.817 163.991C104.862 164.074 104.929 164.142 105.016 164.194C105.105 164.243 105.215 164.267 105.346 164.267C105.517 164.267 105.65 164.226 105.744 164.142C105.838 164.058 105.885 163.954 105.885 163.829C105.885 163.725 105.864 163.643 105.82 163.581C105.777 163.518 105.718 163.466 105.643 163.427C105.57 163.387 105.486 163.353 105.389 163.323C105.295 163.294 105.196 163.261 105.092 163.224C104.896 163.155 104.751 163.07 104.657 162.969C104.563 162.866 104.516 162.732 104.516 162.567C104.513 162.43 104.545 162.308 104.61 162.202C104.675 162.094 104.767 162.011 104.885 161.952C105.006 161.89 105.149 161.859 105.313 161.859C105.475 161.859 105.615 161.89 105.733 161.952C105.854 162.013 105.947 162.098 106.012 162.206C106.08 162.314 106.115 162.437 106.117 162.575H105.798C105.798 162.503 105.78 162.433 105.744 162.365C105.708 162.293 105.652 162.236 105.577 162.191C105.505 162.147 105.413 162.125 105.302 162.125C105.164 162.122 105.051 162.158 104.961 162.232C104.874 162.306 104.831 162.408 104.831 162.538C104.831 162.649 104.861 162.733 104.922 162.792C104.984 162.851 105.071 162.901 105.182 162.94C105.294 162.977 105.422 163.02 105.567 163.069C105.687 163.113 105.796 163.165 105.893 163.224C105.989 163.283 106.064 163.359 106.117 163.452C106.173 163.546 106.201 163.665 106.201 163.81C106.201 163.933 106.169 164.05 106.106 164.16C106.044 164.269 105.948 164.357 105.82 164.426C105.695 164.495 105.536 164.529 105.346 164.529Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M107.784 164.529C107.536 164.529 107.317 164.474 107.129 164.363C106.943 164.25 106.796 164.093 106.69 163.891C106.586 163.69 106.534 163.457 106.534 163.194C106.534 162.931 106.586 162.7 106.69 162.501C106.796 162.299 106.943 162.142 107.129 162.029C107.317 161.916 107.536 161.859 107.784 161.859C108.036 161.859 108.254 161.916 108.44 162.029C108.629 162.142 108.775 162.299 108.879 162.501C108.983 162.7 109.034 162.931 109.034 163.194C109.034 163.457 108.983 163.69 108.879 163.891C108.775 164.093 108.629 164.25 108.44 164.363C108.254 164.474 108.036 164.529 107.784 164.529ZM107.784 164.256C107.97 164.256 108.133 164.215 108.274 164.131C108.416 164.045 108.526 163.923 108.603 163.766C108.683 163.606 108.723 163.416 108.723 163.194C108.723 162.973 108.683 162.784 108.603 162.626C108.526 162.469 108.416 162.349 108.274 162.265C108.133 162.179 107.97 162.136 107.784 162.136C107.598 162.136 107.434 162.179 107.292 162.265C107.152 162.349 107.042 162.469 106.962 162.626C106.885 162.784 106.846 162.973 106.846 163.194C106.846 163.416 106.885 163.606 106.962 163.766C107.042 163.923 107.152 164.045 107.292 164.131C107.434 164.215 107.598 164.256 107.784 164.256Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M109.474 164.485V161.904H109.778L111.129 163.972V161.904H111.434V164.485H111.129L109.778 162.416V164.485H109.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.181 164.485V162.25L112.771 162.342V162.129L113.282 161.904H113.488V164.485H113.181Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M114.274 164.485V162.25L113.864 162.342V162.129L114.375 161.904H114.582V164.485H114.274Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 194.132L101.147 193.363H93.1314L93.1403 194.132H101.156Z",
    fill: "#DDC8BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 194.132L119.756 193.363H102.089L102.107 194.132H119.774Z",
    fill: "#DDC8BA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M101.156 197.745L101.147 196.977H93.1314L93.1403 197.745H101.156Z",
    fill: "#DDC8BA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 197.745L119.756 196.977H102.089L102.107 197.745H119.774Z",
    fill: "#DDC8BA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M119.774 195.933V195.164H110.576L110.594 195.933H119.774Z",
    fill: "#DDC8BA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M109.785 195.933V195.164H93.1314L93.1492 195.933H109.785Z",
    fill: "#DDC8BA"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 168.799,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint11_linear_10752_2244)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 175.741,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint12_linear_10752_2244)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2766,
    cy: 182.682,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint13_linear_10752_2244)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 224.145C139.064 224.145 140.112 222.935 140.272 221.442C140.432 219.949 139.579 218.748 138.024 218.748C136.887 218.748 136.336 219.958 136.167 221.451C136.007 222.944 136.789 224.145 137.926 224.145ZM137.055 221.539C137.144 220.718 137.446 220.047 138.077 220.047C138.93 220.047 139.401 220.709 139.313 221.531C139.224 222.352 138.646 223.023 138.024 223.023C137.402 223.023 136.966 222.361 137.055 221.539Z",
    fill: "url(#paint14_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 224.145C139.064 224.145 140.112 222.935 140.272 221.442C140.432 219.949 139.579 218.748 138.024 218.748C136.887 218.748 136.336 219.958 136.167 221.451C136.007 222.944 136.789 224.145 137.926 224.145ZM137.055 221.539C137.144 220.718 137.446 220.047 138.077 220.047C138.93 220.047 139.401 220.709 139.313 221.531C139.224 222.352 138.646 223.023 138.024 223.023C137.402 223.023 136.966 222.361 137.055 221.539Z",
    fill: "#398191"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M129.032 227.341L137.031 227.318C137.276 227.317 137.474 227.119 137.474 226.875L137.441 216.036C137.44 215.792 137.241 215.595 136.996 215.596L128.997 215.62C128.752 215.62 128.554 215.819 128.554 216.063L128.587 226.901C128.588 227.145 128.787 227.342 129.032 227.341Z",
    fill: "url(#paint15_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.737 215.611L137.039 215.618C137.279 215.619 137.474 215.814 137.473 216.052L137.441 226.908C137.44 227.147 137.244 227.341 137.004 227.34L134.702 227.333L134.737 215.611Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M129.306 216.187C129.306 216.187 130.879 218.033 130.87 221.646C130.861 225.267 129.315 226.442 129.315 226.442V216.178L129.306 216.187Z",
    fill: "#FFF7E6"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 215.047C133.847 212.265 128.373 213.599 128.373 211.284C128.373 208.97 136.3 208.97 136.3 207.574C136.3 206.179 131.634 206.824 131.634 205.083C131.634 203.343 137.109 202.654 135.42 200.914C135.42 200.914 136.815 201.665 136.353 202.478C135.891 203.29 134.14 204.271 134.14 205.022C134.14 205.772 139.037 206.064 139.037 207.742C139.037 209.421 131.563 210.286 131.563 211.275C131.563 212.609 135.251 212.088 133.447 215.038L133.438 215.047Z",
    fill: "url(#paint16_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10752_2244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 169,
    width: 53,
    height: 59
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M193.949 169.867H141.108V227.345H193.949V169.867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10752_2244)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M176.193 185.326C176.193 187.685 177.402 189.601 178.886 189.601C180.37 189.601 181.578 187.685 181.578 185.326C181.578 182.968 180.37 181.051 178.886 181.051C177.402 181.051 176.193 182.968 176.193 185.326Z",
    fill: "url(#paint17_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M176.193 185.326C176.193 187.685 177.402 189.601 178.886 189.601C180.37 189.601 181.578 187.685 181.578 185.326C181.578 182.968 180.37 181.051 178.886 181.051C177.402 181.051 176.193 182.968 176.193 185.326Z",
    fill: "#A69B9B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M174.504 185.326C174.504 188.232 175.989 190.582 177.819 190.582C179.65 190.582 181.134 188.232 181.134 185.326C181.134 182.42 179.65 180.07 177.819 180.07C175.989 180.07 174.504 182.42 174.504 185.326Z",
    fill: "url(#paint18_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M174.504 185.326C174.504 188.232 175.989 190.582 177.819 190.582C179.65 190.582 181.134 188.232 181.134 185.326C181.134 182.42 179.65 180.07 177.819 180.07C175.989 180.07 174.504 182.42 174.504 185.326Z",
    fill: "#463332"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 192.658H149.372V219.149H167.795V192.658Z",
    fill: "url(#paint19_linear_10752_2244)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 193.578H150.625V218.223H167.795V193.578Z",
    fill: "#FFF4EE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 204.148H152.03V204.996H161.192V204.148Z",
    fill: "#DDC8BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 207.25H152.03V208.098H161.192V207.25Z",
    fill: "#DDC8BA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 205.713H152.03V206.561H156.926V205.713Z",
    fill: "#DDC8BA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 204.148H161.929V204.996H166.382V204.148Z",
    fill: "#DDC8BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 205.713H157.664V206.561H166.382V205.713Z",
    fill: "#DDC8BA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 195.113H152.03V196.836H166.382V195.113Z",
    fill: "#DDC8BA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 198.398H152.03V199.246H161.192V198.398Z",
    fill: "#DDC8BA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 201.5H152.03V202.348H161.192V201.5Z",
    fill: "#DDC8BA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 199.963H152.03V200.811H156.926V199.963Z",
    fill: "#DDC8BA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 198.398H161.929V199.246H166.382V198.398Z",
    fill: "#DDC8BA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M166.382 199.963H157.664V200.811H166.382V199.963Z",
    fill: "#DDC8BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M144.982 206.747C146.067 204.326 148.226 201.694 148.759 201.42C148.928 201.332 149.141 201.252 149.355 201.182V203.54C149.355 203.54 149.346 204.079 149.364 204.229C149.47 204.892 150.279 204.468 151.248 204.176C152.136 203.911 152.918 203.982 152.972 204.379C153.007 204.653 152.27 204.927 151.479 205.271C150.679 205.616 149.852 206.641 148.99 206.967C148.128 207.294 147.622 207.4 147.622 207.4C147.622 207.4 146.991 209.291 146.849 209.52L144.085 208.407L144.982 206.738V206.747Z",
    fill: "url(#paint20_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M144.236 208.134L144.138 208.444L146.849 209.539C146.991 209.318 147.622 207.419 147.622 207.419C147.622 207.419 148.137 207.313 148.99 206.986C149.852 206.659 150.679 205.635 151.479 205.29C152.278 204.946 153.007 204.672 152.972 204.398C152.972 204.354 152.927 204.336 152.9 204.301C152.581 204.672 151.479 204.866 151.008 205.122C150.457 205.423 150.092 205.997 149.328 206.553C148.866 206.889 147.853 206.933 147.275 207.074C146.697 207.207 145.764 207.622 144.662 207.322L144.218 208.143L144.236 208.134Z",
    fill: "#C3694D"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M142.521 224.988C139.259 221.428 143.756 207.498 143.756 207.498C143.756 207.498 146.004 206.88 147.524 209.883C147.524 209.883 148.377 219.123 146.884 221.79C145.391 224.458 142.521 224.979 142.521 224.979V224.988Z",
    fill: "url(#paint21_linear_10752_2244)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M174.06 199.353C176.335 198.505 180.485 204.255 185.035 210.474C191.363 219.122 194.26 224.227 191.443 226.551C188.315 229.13 183.764 223.141 178.663 217.117C173.562 211.084 168.31 201.482 174.06 199.353Z",
    fill: "url(#paint22_linear_10752_2244)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M165.475 172.712C165.475 172.712 163.751 171.608 161.592 173.286C158.65 175.574 160.01 179.019 159.601 181.466L164.489 176.21L165.475 172.712Z",
    fill: "url(#paint23_linear_10752_2244)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M172.914 187.871C172.434 189.85 172.265 191.519 172.105 193.842C171.883 197.111 173.616 198.718 173.616 198.718C171.501 199.266 167.59 199.593 165.315 198.471C165.315 198.471 167.102 197.941 166.426 193.454C165.964 190.38 172.905 187.871 172.905 187.871H172.914Z",
    fill: "url(#paint24_linear_10752_2244)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M163.325 174.594C163.112 177.244 167.111 178.631 169.075 179.973C172.096 182.023 171.829 185.476 171.829 185.476L173.758 185.15C173.758 185.15 178.583 186.669 179.792 186.324C180.619 177.102 178.379 172.774 171.75 171.264C165.973 169.947 163.494 172.518 163.325 174.594Z",
    fill: "url(#paint25_linear_10752_2244)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M181.907 233.389C180.352 227.197 180.379 223.973 180.219 218.664C180.076 214.132 180.778 210.449 179.01 203.347C177.668 197.95 172.532 198.294 167.999 198.162C166.169 198.109 163.929 198.639 162.418 199.637C159.032 201.872 156.74 208.806 157.602 211.845C158.49 214.972 160.534 215.166 160.525 219.83C160.525 223.734 158.597 227.541 157.14 233.159C156.882 235.279 173.696 237.929 181.898 233.38L181.907 233.389Z",
    fill: "url(#paint26_linear_10752_2244)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M164.667 198.62C164.667 198.62 166.08 200.475 170.416 200.396C173.411 200.343 175.135 198.903 175.135 198.903C175.135 198.903 170.825 196.748 164.667 198.62Z",
    fill: "url(#paint27_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M162.525 219.105C162.436 214.909 160.232 210.713 160.232 210.713L157.895 212.674C158.872 215.05 160.534 215.615 160.525 219.829C160.525 223.733 158.597 227.54 157.139 233.158C157.104 233.441 157.388 233.732 157.904 234.024C159.512 229.643 162.614 223.177 162.525 219.105Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M170.55 200.396C173.456 200.307 175.135 198.912 175.135 198.912C175.135 198.912 174.451 198.576 173.242 198.276C172.745 197.604 171.945 196.147 172.105 193.841C172.194 192.552 172.292 191.465 172.434 190.414L166.453 196.668C166.417 196.827 166.373 196.951 166.328 197.092C166.764 197.587 168.292 199.212 170.55 200.396Z",
    fill: "#AC6B53"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M164.818 199.195C162.365 198.135 157.202 203.611 151.541 209.539C143.676 217.78 139.952 222.718 142.858 225.341C146.084 228.248 151.719 222.559 157.975 216.879C164.231 211.199 170.994 201.889 164.818 199.204V199.195Z",
    fill: "url(#paint28_linear_10752_2244)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M179.979 181.705C179.979 184.894 182.254 192.393 180.192 194.875C179.206 196.059 175.126 197.234 170.932 197.34C166.8 197.446 162.552 196.492 161.032 195.37C157.966 193.109 160.463 188.003 160.961 183.542C161.459 179.081 163.103 172.889 171.572 173.772C179.054 174.55 179.979 181.705 179.979 181.705Z",
    fill: "url(#paint29_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M162.267 181.81C162.267 181.81 162.836 173.834 171.314 173.754C178.886 173.683 179.792 180.609 179.792 180.609C179.792 180.609 179.579 172.014 170.879 172.102C160.801 172.191 160.534 181.307 160.534 181.307L162.267 181.801V181.81Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M160.472 180.044C160.197 180.044 159.93 180.097 159.672 180.185C159.672 180.636 159.664 181.069 159.592 181.466L160.863 180.097C160.73 180.07 160.606 180.035 160.463 180.035L160.472 180.044Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M160.472 191.404C162.489 191.404 164.116 188.86 164.116 185.724C164.116 183.189 163.04 181.06 161.565 180.336C161.263 181.422 161.076 182.527 160.961 183.551C160.677 186.113 159.735 188.887 159.566 191.21C159.859 191.325 160.161 191.413 160.472 191.413V191.404Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M179.979 181.705C179.979 181.705 179.952 181.546 179.899 181.289C179.676 177.889 178.708 175.477 176.913 173.799C178.468 176.36 178.45 179.77 173.171 180.397C163.929 181.493 160.436 176.74 160.596 174.329C159.006 176.537 159.948 179.381 159.601 181.475L162.072 178.816C161.432 180.371 161.13 182.049 160.97 183.542C160.472 188.003 157.975 193.1 161.041 195.37C162.56 196.492 166.808 197.446 170.941 197.34C175.135 197.234 179.214 196.05 180.201 194.875C182.263 192.393 179.987 184.893 179.987 181.705H179.979Z",
    fill: "#491D17"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M161.814 181.21C161.814 181.21 162.4 173.234 171.092 173.154C178.859 173.084 179.783 180.009 179.783 180.009C179.783 180.009 179.561 171.414 170.638 171.503C160.303 171.591 160.028 180.707 160.028 180.707L161.805 181.202L161.814 181.21Z",
    fill: "url(#paint30_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M170.985 172.616C162.587 172.695 161.37 180.08 161.254 181.052L161.823 181.211C161.823 181.211 162.409 173.234 171.101 173.155C178.868 173.084 179.792 180.009 179.792 180.009C179.792 180.009 179.668 178.472 178.886 176.706C177.748 174.762 175.473 172.572 170.985 172.616Z",
    fill: "#463332"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 190.555C161.974 190.555 163.458 188.201 163.458 185.299C163.458 182.396 161.974 180.043 160.143 180.043C158.312 180.043 156.828 182.396 156.828 185.299C156.828 188.201 158.312 190.555 160.143 190.555Z",
    fill: "url(#paint31_linear_10752_2244)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M161.734 185.326C161.734 187.685 160.525 189.601 159.041 189.601C157.557 189.601 156.349 187.685 156.349 185.326C156.349 182.968 157.557 181.051 159.041 181.051C160.525 181.051 161.734 182.968 161.734 185.326Z",
    fill: "url(#paint32_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 180.043C160.063 180.043 160.001 180.069 159.921 180.078C161.467 180.405 162.658 182.49 162.658 185.025C162.658 187.799 161.245 190.042 159.494 190.042C159.068 190.042 158.659 189.901 158.286 189.654C158.819 190.219 159.45 190.555 160.143 190.555C161.974 190.555 163.458 188.205 163.458 185.299C163.458 182.393 161.974 180.043 160.143 180.043Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M159.041 181.051C158.544 181.051 158.081 181.28 157.673 181.66C157.921 181.519 158.179 181.422 158.464 181.422C159.717 181.422 160.739 183.038 160.739 185.035C160.739 187.031 159.717 188.647 158.464 188.647C157.664 188.647 156.962 187.985 156.553 186.987C156.962 188.533 157.921 189.61 159.041 189.61C160.534 189.61 161.734 187.693 161.734 185.335C161.734 182.976 160.525 181.06 159.041 181.06V181.051Z",
    fill: "#A69B9B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M158.561 182.139C159.814 182.351 158.321 184.568 157.655 184.471C156.615 184.321 157.468 181.954 158.561 182.139Z",
    fill: "#FFF7E6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M157.264 184.816C158.046 184.692 157.753 185.849 157.379 185.894C156.802 185.964 156.651 184.913 157.264 184.816Z",
    fill: "#FFF7E6"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M190.749 220.908C190.003 233.593 185.408 240.889 176.246 240.889C167.084 240.889 163.342 233.593 164.089 220.908C164.835 208.224 168.257 194.965 178.948 194.965C189.639 194.965 191.505 208.224 190.758 220.908H190.749Z",
    fill: "url(#paint33_linear_10752_2244)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M192.767 220.908C192.02 233.593 187.426 240.889 178.263 240.889C169.101 240.889 165.36 233.593 166.106 220.908C166.853 208.224 170.274 194.965 180.965 194.965C191.656 194.965 193.522 208.224 192.776 220.908H192.767Z",
    fill: "url(#paint34_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M185.089 195.814C190.376 199.762 191.363 209.593 190.803 219.116C190.083 231.394 185.631 238.461 176.753 238.461C172.576 238.461 169.581 236.879 167.635 233.938C169.492 238.443 172.967 240.89 178.255 240.89C187.417 240.89 192.02 233.593 192.758 220.909C193.389 210.088 192.109 198.87 185.08 195.805L185.089 195.814Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M161.378 213.451C161.378 213.451 162.489 210.783 162.223 210.138C162.223 210.138 158.161 214.317 157.539 214.873C151.861 220.032 146.449 226.038 143.525 223.397C140.841 220.977 143.009 211.79 144.298 207.453C143.96 207.453 143.756 207.506 143.756 207.506C143.756 207.506 139.499 220.721 142.307 224.678C142.352 224.749 142.396 224.828 142.45 224.899C142.476 224.925 142.485 224.97 142.512 224.996H142.529C142.627 225.12 142.725 225.235 142.849 225.349C146.075 228.255 151.71 222.567 157.966 216.887C158.659 216.26 160.525 214.44 161.378 213.46V213.451Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M147.719 213.302C147.648 211.367 147.515 209.892 147.515 209.892C146.004 206.88 143.747 207.507 143.747 207.507C143.747 207.507 139.25 221.437 142.512 224.997C140.619 221.305 145.942 215.554 147.648 213.735L147.711 213.311L147.719 213.302Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M149.87 204.581C149.87 204.581 149.87 204.581 149.879 204.581C149.603 204.608 149.417 204.528 149.372 204.237C149.346 204.087 149.372 203.548 149.372 203.548V202.152C149.292 202.214 148.501 202.965 148.546 203.663C148.599 204.493 149.204 204.705 149.87 204.59V204.581Z",
    fill: "#C3694D"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9597 225.819V220.528H69.0177V219H112.439C113.194 219 113.807 219.609 113.807 220.36V225.996C113.807 226.747 113.194 227.356 112.439 227.356H69.0177V225.828H69.9597V225.819Z",
    fill: "url(#paint35_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M112.439 218.999H92.6033V227.347H112.439C113.194 227.347 113.807 226.737 113.807 225.986V220.351C113.807 219.6 113.194 218.99 112.439 218.99V218.999Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M111.763 225.818H71.115V220.527H111.763C112.243 220.527 112.625 220.916 112.625 221.384V224.953C112.625 225.43 112.234 225.81 111.763 225.81V225.818Z",
    fill: "#60578F"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M110.608 225.818H69.9598V220.527H110.608C111.088 220.527 111.47 220.916 111.47 221.384V224.953C111.47 225.43 111.079 225.81 110.608 225.81V225.818Z",
    fill: "#CEB6AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.527H69.9598V225.818H91.697V220.527Z",
    fill: "#CEB6AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.527H69.9598V225.818H91.697V220.527Z",
    fill: "#FFE6D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9594 220.527H110.599C111.079 220.527 111.461 220.916 111.461 221.384V222.603C111.461 222.126 111.07 221.746 110.599 221.746H90.9594V220.527Z",
    fill: "#B29B93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M110.004 222.823C110.004 222.823 109.435 222.867 108.573 222.911C107.711 222.956 106.565 222.973 105.418 222.982C104.272 222.973 103.125 222.956 102.263 222.911C101.401 222.867 100.833 222.823 100.833 222.823C100.833 222.823 101.41 222.779 102.263 222.735C103.125 222.691 104.272 222.673 105.418 222.664C106.565 222.673 107.711 222.691 108.573 222.735C109.435 222.779 110.004 222.823 110.004 222.823Z",
    fill: "#B29B93"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M107.276 224.846C107.276 224.846 106.431 224.882 105.178 224.935C103.916 224.979 102.237 224.997 100.557 225.005C98.8775 224.997 97.1979 224.979 95.936 224.935C94.6741 224.882 93.8387 224.846 93.8387 224.846C93.8387 224.846 94.683 224.811 95.936 224.758C97.1979 224.714 98.8775 224.696 100.557 224.688C102.237 224.696 103.916 224.714 105.178 224.758C106.44 224.811 107.276 224.846 107.276 224.846Z",
    fill: "#B29B93"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6128 223.798C90.6128 223.798 89.5375 223.833 87.929 223.877C86.3204 223.912 84.1787 223.93 82.037 223.939C79.8953 223.93 77.7447 223.912 76.145 223.877C74.5365 223.833 73.4612 223.798 73.4612 223.798C73.4612 223.798 74.5365 223.762 76.145 223.718C77.7535 223.683 79.8953 223.665 82.037 223.656C84.1787 223.665 86.3293 223.683 87.929 223.718C89.5375 223.762 90.6128 223.798 90.6128 223.798Z",
    fill: "#CEB6AA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2245 222.551C78.2245 222.551 77.7624 222.596 77.0781 222.631C76.3939 222.666 75.4696 222.684 74.5543 222.693C73.6389 222.684 72.7236 222.666 72.0304 222.631C71.3461 222.596 70.884 222.551 70.884 222.551C70.884 222.551 71.3461 222.507 72.0304 222.472C72.7147 222.437 73.6389 222.419 74.5543 222.41C75.4696 222.419 76.385 222.437 77.0781 222.472C77.7624 222.507 78.2245 222.551 78.2245 222.551Z",
    fill: "#CEB6AA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8312 224.901C87.8312 224.901 87.1291 224.936 86.0805 224.981C85.0318 225.016 83.6277 225.034 82.2325 225.042C80.8284 225.034 79.4331 225.016 78.3845 224.981C77.3359 224.936 76.6338 224.901 76.6338 224.901L78.3845 224.822C79.4331 224.786 80.8373 224.769 82.2325 224.76C83.6366 224.769 85.0318 224.786 86.0805 224.822C87.1291 224.866 87.8312 224.901 87.8312 224.901Z",
    fill: "#CEB6AA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M91.697 220.527H69.9598V221.729H91.697V220.527Z",
    fill: "#CEB6AA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 214.502V211.225H107.48V210.023H73.2924C72.697 210.023 72.2171 210.5 72.2171 211.092V214.643C72.2171 215.235 72.697 215.712 73.2924 215.712H107.48V214.511H106.734V214.502Z",
    fill: "url(#paint36_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8256 211.224H105.827V214.501H73.8256C73.4524 214.501 73.1414 214.2 73.1414 213.821V211.895C73.1414 211.524 73.4435 211.215 73.8256 211.215V211.224Z",
    fill: "#A0335D"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7321 211.224H106.734V214.501H74.7321C74.3588 214.501 74.0478 214.2 74.0478 213.821V211.895C74.0478 211.524 74.3499 211.215 74.7321 211.215V211.224Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M107.48 211.225V210.023H90.0352V215.712H107.48V214.511H106.734V211.234H107.48V211.225Z",
    fill: "#A0335D"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V214.502H106.734V211.225Z",
    fill: "#CEB6AA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V214.502H106.734V211.225Z",
    fill: "#CEB6AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1951 211.225H74.7321C74.3588 211.225 74.0478 211.525 74.0478 211.905V212.868C74.0478 212.497 74.3499 212.187 74.7321 212.187H90.1951V211.225Z",
    fill: "#CEB6AA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2032 212.849L76.3318 212.779C77.0072 212.743 77.9136 212.734 78.8112 212.717C79.7177 212.726 80.6152 212.734 81.2906 212.77C81.966 212.814 82.4193 212.84 82.4193 212.84C82.4193 212.84 81.966 212.867 81.2906 212.911C80.6152 212.946 79.7088 212.955 78.8112 212.964C77.9048 212.955 77.0072 212.946 76.3318 212.902C75.6564 212.858 75.2032 212.832 75.2032 212.832V212.849Z",
    fill: "#CEB6AA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3537 213.732C77.3537 213.732 78.0113 213.706 79.0066 213.661C80.0019 213.626 81.3172 213.617 82.6413 213.6C83.9655 213.608 85.2896 213.617 86.276 213.653C87.2714 213.697 87.929 213.723 87.929 213.723C87.929 213.723 87.2714 213.75 86.276 213.794C85.2807 213.829 83.9655 213.838 82.6413 213.847C81.3172 213.838 79.9931 213.829 79.0066 213.785C78.0113 213.741 77.3537 213.714 77.3537 213.714V213.732Z",
    fill: "#CEB6AA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4707 212.913C90.4707 212.913 91.3149 212.877 92.5769 212.833C93.8388 212.789 95.5273 212.78 97.2158 212.771C98.9043 212.78 100.593 212.798 101.855 212.833C103.117 212.886 103.961 212.913 103.961 212.913C103.961 212.913 103.117 212.948 101.855 212.992C100.593 213.036 98.9043 213.045 97.2158 213.054C95.5273 213.045 93.8388 213.028 92.5769 212.992C91.3149 212.939 90.4707 212.913 90.4707 212.913Z",
    fill: "#B29B93"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7584 213.769C95.7584 213.769 97.9623 213.636 100.166 213.645C102.37 213.636 104.574 213.769 104.574 213.769C104.574 213.769 102.37 213.901 100.166 213.892C97.9623 213.901 95.7584 213.769 95.7584 213.769Z",
    fill: "#B29B93"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 211.225H89.6175V212.17H106.734V211.225Z",
    fill: "#B29B93"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6843 218.274V216.463H69V215.668H112.812C113.354 215.668 113.798 216.039 113.798 216.498V218.238C113.798 218.698 113.354 219.069 112.812 219.069H69V218.274H69.6843Z",
    fill: "url(#paint37_linear_10752_2244)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M112.812 215.668H91.1282V219.069H112.812C113.354 219.069 113.798 218.698 113.798 218.238V216.498C113.798 216.039 113.354 215.668 112.812 215.668Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M112.332 218.273H70.5285V216.463H112.332C112.679 216.463 112.954 216.745 112.954 217.081V217.655C112.954 218 112.67 218.273 112.332 218.273Z",
    fill: "#AA2424"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M111.497 218.273H69.6932V216.463H111.497C111.843 216.463 112.119 216.745 112.119 217.081V217.655C112.119 218 111.835 218.273 111.497 218.273Z",
    fill: "#CEB6AA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V218.274H91.5192V216.463Z",
    fill: "#CEB6AA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V218.274H91.5192V216.463Z",
    fill: "#FFE6D6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9861 216.463H111.497C111.843 216.463 112.119 216.746 112.119 217.081V217.965C112.119 217.62 111.835 217.346 111.497 217.346H90.9861V216.463Z",
    fill: "#B29B93"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 216.463H69.6843V217.329H91.5192V216.463Z",
    fill: "#CEB6AA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M29.62 64V52.06H25.54V50H36.28V52.06H32.18V64H29.62ZM40.9195 64.24C39.9195 64.24 39.0329 64.0267 38.2595 63.6C37.4862 63.1733 36.8795 62.5733 36.4395 61.8C35.9995 61.0267 35.7795 60.1333 35.7795 59.12C35.7795 58.0933 35.9929 57.18 36.4195 56.38C36.8595 55.58 37.4595 54.96 38.2195 54.52C38.9929 54.0667 39.8995 53.84 40.9395 53.84C41.9129 53.84 42.7729 54.0533 43.5195 54.48C44.2662 54.9067 44.8462 55.4933 45.2595 56.24C45.6862 56.9733 45.8995 57.7933 45.8995 58.7C45.8995 58.8467 45.8929 59 45.8795 59.16C45.8795 59.32 45.8729 59.4867 45.8595 59.66H38.3195C38.3729 60.4333 38.6395 61.04 39.1195 61.48C39.6129 61.92 40.2062 62.14 40.8995 62.14C41.4195 62.14 41.8529 62.0267 42.1995 61.8C42.5595 61.56 42.8262 61.2533 42.9995 60.88H45.5995C45.4129 61.5067 45.0995 62.08 44.6595 62.6C44.2329 63.1067 43.6995 63.5067 43.0595 63.8C42.4329 64.0933 41.7195 64.24 40.9195 64.24ZM40.9395 55.92C40.3129 55.92 39.7595 56.1 39.2795 56.46C38.7995 56.8067 38.4929 57.34 38.3595 58.06H43.2995C43.2595 57.4067 43.0195 56.8867 42.5795 56.5C42.1395 56.1133 41.5929 55.92 40.9395 55.92ZM51.2527 64.24C50.3993 64.24 49.6993 64.1067 49.1527 63.84C48.606 63.56 48.1993 63.1933 47.9327 62.74C47.666 62.2867 47.5327 61.7867 47.5327 61.24C47.5327 60.32 47.8927 59.5733 48.6127 59C49.3327 58.4267 50.4127 58.14 51.8527 58.14H54.3727V57.9C54.3727 57.22 54.1793 56.72 53.7927 56.4C53.406 56.08 52.926 55.92 52.3527 55.92C51.8327 55.92 51.3793 56.0467 50.9927 56.3C50.606 56.54 50.366 56.9 50.2727 57.38H47.7727C47.8393 56.66 48.0793 56.0333 48.4927 55.5C48.9193 54.9667 49.466 54.56 50.1327 54.28C50.7993 53.9867 51.546 53.84 52.3727 53.84C53.786 53.84 54.8993 54.1933 55.7127 54.9C56.526 55.6067 56.9327 56.6067 56.9327 57.9V64H54.7527L54.5127 62.4C54.2193 62.9333 53.806 63.3733 53.2727 63.72C52.7527 64.0667 52.0793 64.24 51.2527 64.24ZM51.8327 62.24C52.566 62.24 53.1327 62 53.5327 61.52C53.946 61.04 54.206 60.4467 54.3127 59.74H52.1327C51.4527 59.74 50.966 59.8667 50.6727 60.12C50.3793 60.36 50.2327 60.66 50.2327 61.02C50.2327 61.4067 50.3793 61.7067 50.6727 61.92C50.966 62.1333 51.3527 62.24 51.8327 62.24ZM64.0156 64.24C63.0023 64.24 62.109 64.02 61.3356 63.58C60.5623 63.14 59.949 62.5267 59.4956 61.74C59.0556 60.9533 58.8356 60.0533 58.8356 59.04C58.8356 58.0267 59.0556 57.1267 59.4956 56.34C59.949 55.5533 60.5623 54.94 61.3356 54.5C62.109 54.06 63.0023 53.84 64.0156 53.84C65.2823 53.84 66.349 54.1733 67.2156 54.84C68.0823 55.4933 68.6356 56.4 68.8756 57.56H66.1756C66.0423 57.08 65.7756 56.7067 65.3756 56.44C64.989 56.16 64.529 56.02 63.9956 56.02C63.289 56.02 62.689 56.2867 62.1956 56.82C61.7023 57.3533 61.4556 58.0933 61.4556 59.04C61.4556 59.9867 61.7023 60.7267 62.1956 61.26C62.689 61.7933 63.289 62.06 63.9956 62.06C64.529 62.06 64.989 61.9267 65.3756 61.66C65.7756 61.3933 66.0423 61.0133 66.1756 60.52H68.8756C68.6356 61.64 68.0823 62.54 67.2156 63.22C66.349 63.9 65.2823 64.24 64.0156 64.24ZM70.9278 64V49.6H73.4878V55.6C73.8211 55.0533 74.2678 54.6267 74.8278 54.32C75.4011 54 76.0545 53.84 76.7878 53.84C78.0145 53.84 78.9611 54.2267 79.6278 55C80.3078 55.7733 80.6478 56.9067 80.6478 58.4V64H78.1078V58.64C78.1078 57.7867 77.9345 57.1333 77.5878 56.68C77.2545 56.2267 76.7211 56 75.9878 56C75.2678 56 74.6678 56.2533 74.1878 56.76C73.7211 57.2667 73.4878 57.9733 73.4878 58.88V64H70.9278ZM87.6958 64.24C86.6958 64.24 85.8091 64.0267 85.0358 63.6C84.2624 63.1733 83.6558 62.5733 83.2158 61.8C82.7758 61.0267 82.5558 60.1333 82.5558 59.12C82.5558 58.0933 82.7691 57.18 83.1958 56.38C83.6358 55.58 84.2358 54.96 84.9958 54.52C85.7691 54.0667 86.6758 53.84 87.7158 53.84C88.6891 53.84 89.5491 54.0533 90.2958 54.48C91.0424 54.9067 91.6224 55.4933 92.0358 56.24C92.4624 56.9733 92.6758 57.7933 92.6758 58.7C92.6758 58.8467 92.6691 59 92.6558 59.16C92.6558 59.32 92.6491 59.4867 92.6358 59.66H85.0958C85.1491 60.4333 85.4158 61.04 85.8958 61.48C86.3891 61.92 86.9824 62.14 87.6758 62.14C88.1958 62.14 88.6291 62.0267 88.9758 61.8C89.3358 61.56 89.6024 61.2533 89.7758 60.88H92.3758C92.1891 61.5067 91.8758 62.08 91.4358 62.6C91.0091 63.1067 90.4758 63.5067 89.8358 63.8C89.2091 64.0933 88.4958 64.24 87.6958 64.24ZM87.7158 55.92C87.0891 55.92 86.5358 56.1 86.0558 56.46C85.5758 56.8067 85.2691 57.34 85.1358 58.06H90.0758C90.0358 57.4067 89.7958 56.8867 89.3558 56.5C88.9158 56.1133 88.3691 55.92 87.7158 55.92ZM94.6089 64V54.08H96.8889L97.1289 55.94C97.4889 55.3 97.9756 54.7933 98.5889 54.42C99.2156 54.0333 99.9489 53.84 100.789 53.84V56.54H100.069C99.5089 56.54 99.0089 56.6267 98.5689 56.8C98.1289 56.9733 97.7822 57.2733 97.5289 57.7C97.2889 58.1267 97.1689 58.72 97.1689 59.48V64H94.6089ZM25.46 90L30.58 76H33.46L38.58 90H35.86L34.74 86.76H29.28L28.14 90H25.46ZM29.98 84.76H34.04L32 78.94L29.98 84.76ZM44.2034 90.24C43.3234 90.24 42.5501 90.1 41.8834 89.82C41.2168 89.5267 40.6834 89.1267 40.2834 88.62C39.8834 88.1133 39.6434 87.5267 39.5634 86.86H42.1434C42.2234 87.2467 42.4368 87.58 42.7834 87.86C43.1434 88.1267 43.6034 88.26 44.1634 88.26C44.7234 88.26 45.1301 88.1467 45.3834 87.92C45.6501 87.6933 45.7834 87.4333 45.7834 87.14C45.7834 86.7133 45.5968 86.4267 45.2234 86.28C44.8501 86.12 44.3301 85.9667 43.6634 85.82C43.2368 85.7267 42.8034 85.6133 42.3634 85.48C41.9234 85.3467 41.5168 85.18 41.1434 84.98C40.7834 84.7667 40.4901 84.5 40.2634 84.18C40.0368 83.8467 39.9234 83.44 39.9234 82.96C39.9234 82.08 40.2701 81.34 40.9634 80.74C41.6701 80.14 42.6568 79.84 43.9234 79.84C45.0968 79.84 46.0301 80.1133 46.7234 80.66C47.4301 81.2067 47.8501 81.96 47.9834 82.92H45.5634C45.4168 82.1867 44.8634 81.82 43.9034 81.82C43.4234 81.82 43.0501 81.9133 42.7834 82.1C42.5301 82.2867 42.4034 82.52 42.4034 82.8C42.4034 83.0933 42.5968 83.3267 42.9834 83.5C43.3701 83.6733 43.8834 83.8333 44.5234 83.98C45.2168 84.14 45.8501 84.32 46.4234 84.52C47.0101 84.7067 47.4768 84.9933 47.8234 85.38C48.1701 85.7533 48.3434 86.2933 48.3434 87C48.3568 87.6133 48.1968 88.1667 47.8634 88.66C47.5301 89.1533 47.0501 89.54 46.4234 89.82C45.7968 90.1 45.0568 90.24 44.2034 90.24ZM54.4912 90.24C53.6112 90.24 52.8379 90.1 52.1712 89.82C51.5046 89.5267 50.9712 89.1267 50.5712 88.62C50.1712 88.1133 49.9312 87.5267 49.8512 86.86H52.4312C52.5112 87.2467 52.7246 87.58 53.0712 87.86C53.4312 88.1267 53.8912 88.26 54.4512 88.26C55.0112 88.26 55.4179 88.1467 55.6712 87.92C55.9379 87.6933 56.0712 87.4333 56.0712 87.14C56.0712 86.7133 55.8846 86.4267 55.5112 86.28C55.1379 86.12 54.6179 85.9667 53.9512 85.82C53.5246 85.7267 53.0912 85.6133 52.6512 85.48C52.2112 85.3467 51.8046 85.18 51.4312 84.98C51.0712 84.7667 50.7779 84.5 50.5512 84.18C50.3246 83.8467 50.2112 83.44 50.2112 82.96C50.2112 82.08 50.5579 81.34 51.2512 80.74C51.9579 80.14 52.9446 79.84 54.2112 79.84C55.3846 79.84 56.3179 80.1133 57.0113 80.66C57.7179 81.2067 58.1379 81.96 58.2712 82.92H55.8513C55.7046 82.1867 55.1512 81.82 54.1912 81.82C53.7112 81.82 53.3379 81.9133 53.0712 82.1C52.8179 82.2867 52.6912 82.52 52.6912 82.8C52.6912 83.0933 52.8846 83.3267 53.2712 83.5C53.6579 83.6733 54.1712 83.8333 54.8112 83.98C55.5046 84.14 56.1379 84.32 56.7112 84.52C57.2979 84.7067 57.7646 84.9933 58.1113 85.38C58.4579 85.7533 58.6313 86.2933 58.6313 87C58.6446 87.6133 58.4846 88.1667 58.1512 88.66C57.8179 89.1533 57.3379 89.54 56.7112 89.82C56.0846 90.1 55.3446 90.24 54.4912 90.24ZM62.0591 78.54C61.5924 78.54 61.2057 78.4 60.8991 78.12C60.6057 77.84 60.4591 77.4867 60.4591 77.06C60.4591 76.6333 60.6057 76.2867 60.8991 76.02C61.2057 75.74 61.5924 75.6 62.0591 75.6C62.5257 75.6 62.9057 75.74 63.1991 76.02C63.5057 76.2867 63.6591 76.6333 63.6591 77.06C63.6591 77.4867 63.5057 77.84 63.1991 78.12C62.9057 78.4 62.5257 78.54 62.0591 78.54ZM60.7791 90V80.08H63.3391V90H60.7791ZM69.8911 90.24C69.0111 90.24 68.2378 90.1 67.5711 89.82C66.9044 89.5267 66.3711 89.1267 65.9711 88.62C65.5711 88.1133 65.3311 87.5267 65.2511 86.86H67.8311C67.9111 87.2467 68.1244 87.58 68.4711 87.86C68.8311 88.1267 69.2911 88.26 69.8511 88.26C70.4111 88.26 70.8178 88.1467 71.0711 87.92C71.3378 87.6933 71.4711 87.4333 71.4711 87.14C71.4711 86.7133 71.2844 86.4267 70.9111 86.28C70.5378 86.12 70.0178 85.9667 69.3511 85.82C68.9244 85.7267 68.4911 85.6133 68.0511 85.48C67.6111 85.3467 67.2044 85.18 66.8311 84.98C66.4711 84.7667 66.1778 84.5 65.9511 84.18C65.7244 83.8467 65.6111 83.44 65.6111 82.96C65.6111 82.08 65.9578 81.34 66.6511 80.74C67.3578 80.14 68.3444 79.84 69.6111 79.84C70.7844 79.84 71.7178 80.1133 72.4111 80.66C73.1178 81.2067 73.5378 81.96 73.6711 82.92H71.2511C71.1044 82.1867 70.5511 81.82 69.5911 81.82C69.1111 81.82 68.7378 81.9133 68.4711 82.1C68.2178 82.2867 68.0911 82.52 68.0911 82.8C68.0911 83.0933 68.2844 83.3267 68.6711 83.5C69.0578 83.6733 69.5711 83.8333 70.2111 83.98C70.9044 84.14 71.5378 84.32 72.1111 84.52C72.6978 84.7067 73.1644 84.9933 73.5111 85.38C73.8578 85.7533 74.0311 86.2933 74.0311 87C74.0444 87.6133 73.8844 88.1667 73.5511 88.66C73.2178 89.1533 72.7378 89.54 72.1111 89.82C71.4844 90.1 70.7444 90.24 69.8911 90.24ZM80.1864 90C79.1464 90 78.3131 89.7467 77.6864 89.24C77.0597 88.7333 76.7464 87.8333 76.7464 86.54V82.22H75.0464V80.08H76.7464L77.0464 77.42H79.3064V80.08H81.9864V82.22H79.3064V86.56C79.3064 87.04 79.4064 87.3733 79.6064 87.56C79.8197 87.7333 80.1797 87.82 80.6864 87.82H81.9264V90H80.1864ZM87.3844 90.24C86.531 90.24 85.831 90.1067 85.2844 89.84C84.7377 89.56 84.331 89.1933 84.0644 88.74C83.7977 88.2867 83.6644 87.7867 83.6644 87.24C83.6644 86.32 84.0244 85.5733 84.7444 85C85.4644 84.4267 86.5444 84.14 87.9844 84.14H90.5044V83.9C90.5044 83.22 90.311 82.72 89.9244 82.4C89.5377 82.08 89.0577 81.92 88.4844 81.92C87.9644 81.92 87.511 82.0467 87.1244 82.3C86.7377 82.54 86.4977 82.9 86.4044 83.38H83.9044C83.971 82.66 84.211 82.0333 84.6244 81.5C85.051 80.9667 85.5977 80.56 86.2644 80.28C86.931 79.9867 87.6777 79.84 88.5044 79.84C89.9177 79.84 91.031 80.1933 91.8444 80.9C92.6577 81.6067 93.0644 82.6067 93.0644 83.9V90H90.8844L90.6444 88.4C90.351 88.9333 89.9377 89.3733 89.4044 89.72C88.8844 90.0667 88.211 90.24 87.3844 90.24ZM87.9644 88.24C88.6977 88.24 89.2644 88 89.6644 87.52C90.0777 87.04 90.3377 86.4467 90.4444 85.74H88.2644C87.5844 85.74 87.0977 85.8667 86.8044 86.12C86.511 86.36 86.3644 86.66 86.3644 87.02C86.3644 87.4067 86.511 87.7067 86.8044 87.92C87.0977 88.1333 87.4844 88.24 87.9644 88.24ZM95.2873 90V80.08H97.5473L97.7473 81.76C98.054 81.1733 98.494 80.7067 99.0673 80.36C99.654 80.0133 100.341 79.84 101.127 79.84C102.354 79.84 103.307 80.2267 103.987 81C104.667 81.7733 105.007 82.9067 105.007 84.4V90H102.447V84.64C102.447 83.7867 102.274 83.1333 101.927 82.68C101.581 82.2267 101.041 82 100.307 82C99.5873 82 98.994 82.2533 98.5273 82.76C98.074 83.2667 97.8473 83.9733 97.8473 84.88V90H95.2873ZM112.095 90.24C111.082 90.24 110.189 90.02 109.415 89.58C108.642 89.14 108.029 88.5267 107.575 87.74C107.135 86.9533 106.915 86.0533 106.915 85.04C106.915 84.0267 107.135 83.1267 107.575 82.34C108.029 81.5533 108.642 80.94 109.415 80.5C110.189 80.06 111.082 79.84 112.095 79.84C113.362 79.84 114.429 80.1733 115.295 80.84C116.162 81.4933 116.715 82.4 116.955 83.56H114.255C114.122 83.08 113.855 82.7067 113.455 82.44C113.069 82.16 112.609 82.02 112.075 82.02C111.369 82.02 110.769 82.2867 110.275 82.82C109.782 83.3533 109.535 84.0933 109.535 85.04C109.535 85.9867 109.782 86.7267 110.275 87.26C110.769 87.7933 111.369 88.06 112.075 88.06C112.609 88.06 113.069 87.9267 113.455 87.66C113.855 87.3933 114.122 87.0133 114.255 86.52H116.955C116.715 87.64 116.162 88.54 115.295 89.22C114.429 89.9 113.362 90.24 112.095 90.24ZM123.827 90.24C122.827 90.24 121.941 90.0267 121.167 89.6C120.394 89.1733 119.787 88.5733 119.347 87.8C118.907 87.0267 118.687 86.1333 118.687 85.12C118.687 84.0933 118.901 83.18 119.327 82.38C119.767 81.58 120.367 80.96 121.127 80.52C121.901 80.0667 122.807 79.84 123.847 79.84C124.821 79.84 125.681 80.0533 126.427 80.48C127.174 80.9067 127.754 81.4933 128.167 82.24C128.594 82.9733 128.807 83.7933 128.807 84.7C128.807 84.8467 128.801 85 128.787 85.16C128.787 85.32 128.781 85.4867 128.767 85.66H121.227C121.281 86.4333 121.547 87.04 122.027 87.48C122.521 87.92 123.114 88.14 123.807 88.14C124.327 88.14 124.761 88.0267 125.107 87.8C125.467 87.56 125.734 87.2533 125.907 86.88H128.507C128.321 87.5067 128.007 88.08 127.567 88.6C127.141 89.1067 126.607 89.5067 125.967 89.8C125.341 90.0933 124.627 90.24 123.827 90.24ZM123.847 81.92C123.221 81.92 122.667 82.1 122.187 82.46C121.707 82.8067 121.401 83.34 121.267 84.06H126.207C126.167 83.4067 125.927 82.8867 125.487 82.5C125.047 82.1133 124.501 81.92 123.847 81.92ZM31.14 116.24C30.1133 116.24 29.2067 116.067 28.42 115.72C27.6333 115.36 27.0133 114.853 26.56 114.2C26.1067 113.533 25.8733 112.727 25.86 111.78H28.56C28.5867 112.433 28.82 112.987 29.26 113.44C29.7133 113.88 30.3333 114.1 31.12 114.1C31.8 114.1 32.34 113.94 32.74 113.62C33.14 113.287 33.34 112.847 33.34 112.3C33.34 111.727 33.16 111.28 32.8 110.96C32.4533 110.64 31.9867 110.38 31.4 110.18C30.8133 109.98 30.1867 109.767 29.52 109.54C28.44 109.167 27.6133 108.687 27.04 108.1C26.48 107.513 26.2 106.733 26.2 105.76C26.1867 104.933 26.38 104.227 26.78 103.64C27.1933 103.04 27.7533 102.58 28.46 102.26C29.1667 101.927 29.98 101.76 30.9 101.76C31.8333 101.76 32.6533 101.927 33.36 102.26C34.08 102.593 34.64 103.06 35.04 103.66C35.4533 104.26 35.6733 104.973 35.7 105.8H32.96C32.9467 105.307 32.7533 104.873 32.38 104.5C32.02 104.113 31.5133 103.92 30.86 103.92C30.3 103.907 29.8267 104.047 29.44 104.34C29.0667 104.62 28.88 105.033 28.88 105.58C28.88 106.047 29.0267 106.42 29.32 106.7C29.6133 106.967 30.0133 107.193 30.52 107.38C31.0267 107.567 31.6067 107.767 32.26 107.98C32.9533 108.22 33.5867 108.5 34.16 108.82C34.7333 109.14 35.1933 109.567 35.54 110.1C35.8867 110.62 36.06 111.293 36.06 112.12C36.06 112.853 35.8733 113.533 35.5 114.16C35.1267 114.787 34.5733 115.293 33.84 115.68C33.1067 116.053 32.2067 116.24 31.14 116.24ZM39.2536 120.4L41.5536 115.34H40.9536L37.0936 106.08H39.8736L42.6536 113.06L45.5536 106.08H48.2736L41.9736 120.4H39.2536ZM53.3389 116.24C52.4589 116.24 51.6856 116.1 51.0189 115.82C50.3522 115.527 49.8189 115.127 49.4189 114.62C49.0189 114.113 48.7789 113.527 48.6989 112.86H51.2789C51.3589 113.247 51.5722 113.58 51.9189 113.86C52.2789 114.127 52.7389 114.26 53.2989 114.26C53.8589 114.26 54.2656 114.147 54.5189 113.92C54.7856 113.693 54.9189 113.433 54.9189 113.14C54.9189 112.713 54.7322 112.427 54.3589 112.28C53.9856 112.12 53.4656 111.967 52.7989 111.82C52.3722 111.727 51.9389 111.613 51.4989 111.48C51.0589 111.347 50.6522 111.18 50.2789 110.98C49.9189 110.767 49.6256 110.5 49.3989 110.18C49.1722 109.847 49.0589 109.44 49.0589 108.96C49.0589 108.08 49.4056 107.34 50.0989 106.74C50.8056 106.14 51.7922 105.84 53.0589 105.84C54.2322 105.84 55.1656 106.113 55.8589 106.66C56.5656 107.207 56.9856 107.96 57.1189 108.92H54.6989C54.5522 108.187 53.9989 107.82 53.0389 107.82C52.5589 107.82 52.1856 107.913 51.9189 108.1C51.6656 108.287 51.5389 108.52 51.5389 108.8C51.5389 109.093 51.7322 109.327 52.1189 109.5C52.5056 109.673 53.0189 109.833 53.6589 109.98C54.3522 110.14 54.9856 110.32 55.5589 110.52C56.1456 110.707 56.6122 110.993 56.9589 111.38C57.3056 111.753 57.4789 112.293 57.4789 113C57.4922 113.613 57.3322 114.167 56.9989 114.66C56.6656 115.153 56.1856 115.54 55.5589 115.82C54.9322 116.1 54.1922 116.24 53.3389 116.24ZM63.6342 116C62.5942 116 61.7609 115.747 61.1342 115.24C60.5076 114.733 60.1942 113.833 60.1942 112.54V108.22H58.4942V106.08H60.1942L60.4942 103.42H62.7542V106.08H65.4342V108.22H62.7542V112.56C62.7542 113.04 62.8542 113.373 63.0542 113.56C63.2676 113.733 63.6276 113.82 64.1342 113.82H65.3742V116H63.6342ZM71.9783 116.24C70.9783 116.24 70.0916 116.027 69.3183 115.6C68.5449 115.173 67.9383 114.573 67.4983 113.8C67.0583 113.027 66.8383 112.133 66.8383 111.12C66.8383 110.093 67.0516 109.18 67.4783 108.38C67.9183 107.58 68.5183 106.96 69.2783 106.52C70.0516 106.067 70.9583 105.84 71.9983 105.84C72.9716 105.84 73.8316 106.053 74.5783 106.48C75.3249 106.907 75.9049 107.493 76.3183 108.24C76.7449 108.973 76.9583 109.793 76.9583 110.7C76.9583 110.847 76.9516 111 76.9383 111.16C76.9383 111.32 76.9316 111.487 76.9183 111.66H69.3783C69.4316 112.433 69.6983 113.04 70.1783 113.48C70.6716 113.92 71.2649 114.14 71.9583 114.14C72.4783 114.14 72.9116 114.027 73.2583 113.8C73.6183 113.56 73.8849 113.253 74.0583 112.88H76.6583C76.4716 113.507 76.1583 114.08 75.7183 114.6C75.2916 115.107 74.7583 115.507 74.1183 115.8C73.4916 116.093 72.7783 116.24 71.9783 116.24ZM71.9983 107.92C71.3716 107.92 70.8183 108.1 70.3383 108.46C69.8583 108.807 69.5516 109.34 69.4183 110.06H74.3583C74.3183 109.407 74.0783 108.887 73.6383 108.5C73.1983 108.113 72.6516 107.92 71.9983 107.92ZM78.8914 116V106.08H81.1514L81.3714 107.42C81.6914 106.94 82.1114 106.56 82.6314 106.28C83.1647 105.987 83.7781 105.84 84.4714 105.84C86.0047 105.84 87.0914 106.433 87.7314 107.62C88.0914 107.073 88.5714 106.64 89.1714 106.32C89.7847 106 90.4514 105.84 91.1714 105.84C92.4647 105.84 93.4581 106.227 94.1514 107C94.8447 107.773 95.1914 108.907 95.1914 110.4V116H92.6314V110.64C92.6314 109.787 92.4647 109.133 92.1314 108.68C91.8114 108.227 91.3114 108 90.6314 108C89.9381 108 89.3781 108.253 88.9514 108.76C88.5381 109.267 88.3314 109.973 88.3314 110.88V116H85.7714V110.64C85.7714 109.787 85.6047 109.133 85.2714 108.68C84.9381 108.227 84.4247 108 83.7314 108C83.0514 108 82.4981 108.253 82.0714 108.76C81.6581 109.267 81.4514 109.973 81.4514 110.88V116H78.8914Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10752_2244)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint38_linear_10752_2244)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint39_linear_10752_2244)"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3624 148.851C46.1258 148.613 46.1258 148.228 46.3624 147.989L48.7109 145.612H39.5053C39.1715 145.612 38.8985 145.337 38.8985 145.001C38.8985 144.665 39.1715 144.39 39.5053 144.39H48.7109L46.3564 142.019C46.1197 141.781 46.1197 141.396 46.3564 141.157C46.593 140.919 46.9753 140.919 47.212 141.157L50.6102 144.573C50.8469 144.812 50.8469 145.197 50.6102 145.435L47.2181 148.851C46.9814 149.083 46.593 149.083 46.3624 148.851Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5452 28.0649L59.7162 27.6792L58.7233 24.5811L60.7707 23.907L60.3903 22.7196L57.1719 23.7804L58.5452 28.0658V28.0649ZM50.8767 20.2796L51.2571 19.0922L54.3124 20.099L55.3053 17L56.4764 17.3857L55.103 21.6712L50.8767 20.2786V20.2796ZM58.1676 28.2549L57.171 28.9895L55.283 26.3537L50.7667 29.223L47.4401 31.5477L50.8497 26.3528L52.5559 23.5828L49.9565 21.6684L50.6809 20.6577L54.276 23.3067L51.0604 27.8758L55.5543 24.6085L58.1667 28.254L58.1676 28.2549Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0572 17.467H59.0524C59.3452 17.467 59.6109 17.5039 59.8505 17.5786C60.0901 17.6523 60.2934 17.761 60.4621 17.9019C60.6309 18.0437 60.7605 18.2177 60.8509 18.4247C60.9413 18.6318 60.987 18.8653 60.987 19.1262V19.1394C60.987 19.4183 60.9367 19.6632 60.8379 19.874C60.7381 20.0858 60.5992 20.2626 60.422 20.4063C60.2449 20.55 60.0332 20.6577 59.7871 20.7296C59.541 20.8014 59.2743 20.8374 58.9862 20.8374H58.3476V22.1864H57.0572V17.467ZM58.9592 19.8135C59.1895 19.8135 59.3703 19.7587 59.5009 19.6471C59.6314 19.5365 59.6967 19.3862 59.6967 19.1962V19.1829C59.6967 18.9797 59.6314 18.8246 59.5009 18.7187C59.3703 18.6128 59.1867 18.559 58.9527 18.559H58.3476V19.8135H58.9592Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31.7481H30.2477C30.8705 31.7481 31.4374 31.8266 31.9474 31.9854C32.4574 32.1433 32.8909 32.3731 33.2499 32.6746C33.6088 32.9762 33.8848 33.3478 34.0778 33.7874C34.2708 34.2279 34.3678 34.7252 34.3678 35.2801V35.3085C34.3678 35.9022 34.2615 36.4241 34.0489 36.8731C33.8363 37.3231 33.5417 37.7013 33.1641 38.0076C32.7865 38.3139 32.3362 38.5436 31.8122 38.6968C31.2882 38.8499 30.7195 38.9265 30.106 38.9265H28.7467V41.7986H26V31.7472V31.7481ZM30.0501 36.7446C30.5405 36.7446 30.9256 36.6264 31.2043 36.391C31.4831 36.1556 31.622 35.8351 31.622 35.4305V35.4011C31.622 34.9682 31.4822 34.6382 31.2043 34.4123C30.9256 34.1863 30.5368 34.0729 30.0361 34.0729H28.7476V36.7436H30.0501V36.7446Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5295 31.7481H40.2163C40.9809 31.7481 41.6279 31.8436 42.1565 32.0355C42.6852 32.2275 43.115 32.495 43.445 32.8391C44.0305 33.4139 44.3233 34.1939 44.3233 35.1799V35.2083C44.3233 35.9835 44.1396 36.6254 43.7714 37.1322C43.4031 37.6398 42.908 38.0275 42.2843 38.295L44.6487 41.7986H41.4769L39.4807 38.7545H38.2771V41.7986H35.5304V31.7472L35.5295 31.7481ZM40.0895 36.5725C40.5613 36.5725 40.9249 36.4647 41.1794 36.2492C41.434 36.0336 41.5617 35.7443 41.5617 35.3804V35.352C41.5617 34.9502 41.4293 34.6505 41.1655 34.4548C40.9007 34.2591 40.538 34.1608 40.0756 34.1608H38.2771V36.5734H40.0895V36.5725Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6949 42C49.9304 42 49.2218 41.8639 48.571 41.5906C47.9203 41.3174 47.3581 40.9468 46.8863 40.4779C46.4145 40.009 46.0435 39.4588 45.775 38.8263C45.5055 38.1948 45.3712 37.5198 45.3712 36.8022V36.7739C45.3712 36.0563 45.5055 35.3785 45.775 34.7422C46.0444 34.106 46.4192 33.5501 46.9003 33.0764C47.3814 32.6028 47.9482 32.2294 48.5999 31.9561C49.2516 31.6829 49.9593 31.5468 50.7238 31.5468C51.4883 31.5468 52.1969 31.6829 52.8477 31.9561C53.4994 32.2294 54.0607 32.5999 54.5324 33.0689C55.0042 33.5378 55.3753 34.088 55.6438 34.7205C55.9123 35.3529 56.0475 36.027 56.0475 36.7446V36.7729C56.0475 37.4905 55.9132 38.1683 55.6438 38.8046C55.3743 39.4418 54.9995 39.9967 54.5184 40.4704C54.0374 40.944 53.4705 41.3174 52.8188 41.5906C52.1671 41.8639 51.4594 42 50.6949 42ZM50.7164 39.4871C51.0949 39.4871 51.4408 39.4153 51.7531 39.2716C52.0655 39.1279 52.3302 38.9341 52.5484 38.6902C52.7656 38.4463 52.9363 38.1617 53.0593 37.8355C53.1824 37.5103 53.2439 37.1653 53.2439 36.8022V36.7739C53.2439 36.4099 53.1824 36.0658 53.0593 35.7396C52.9363 35.4144 52.761 35.127 52.5344 34.8783C52.3069 34.6297 52.0375 34.4312 51.7252 34.2827C51.4128 34.1343 51.0669 34.0606 50.6884 34.0606C50.3099 34.0606 49.9668 34.1324 49.6591 34.2761C49.3514 34.4198 49.0866 34.6136 48.8638 34.8575C48.641 35.1015 48.4713 35.387 48.3529 35.7122C48.2345 36.0374 48.1757 36.3825 48.1757 36.7455V36.7739C48.1757 37.1378 48.2373 37.482 48.3603 37.8072C48.4834 38.1324 48.6559 38.4198 48.8787 38.6684C49.1006 38.9171 49.3682 39.1156 49.6805 39.264C49.9929 39.4125 50.3388 39.4862 50.7173 39.4862L50.7164 39.4871Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4777 31.7481H61.7254C62.3482 31.7481 62.9151 31.8266 63.4251 31.9854C63.9351 32.1443 64.3686 32.3731 64.7276 32.6746C65.0865 32.9762 65.3625 33.3478 65.5555 33.7874C65.7485 34.2279 65.8455 34.7252 65.8455 35.2801V35.3085C65.8455 35.9022 65.7392 36.4241 65.5266 36.8731C65.314 37.3231 65.0194 37.7013 64.6418 38.0076C64.2642 38.3139 63.8139 38.5436 63.2899 38.6968C62.7659 38.8499 62.1972 38.9265 61.5837 38.9265H60.2244V41.7986H57.4777V31.7472V31.7481ZM61.5278 36.7446C62.0182 36.7446 62.4033 36.6264 62.682 36.391C62.9608 36.1556 63.0997 35.8351 63.0997 35.4305V35.4011C63.0997 34.9682 62.9599 34.6382 62.682 34.4123C62.4033 34.1863 62.0135 34.0729 61.5138 34.0729H60.2253V36.7436H61.5278V36.7446Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0081 31.7481H74.9665V34.1173H69.7128V35.6394H74.4705V37.8365H69.7128V39.4304H75.0374V41.7996H67.0081V31.7481Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4527 31.7481H79.1994V39.3586H84V41.7996H76.4527V31.7481Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10752_2244",
    x: 0,
    y: 0,
    width: 189,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10752_2244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10752_2244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10752_2244",
    x: 18,
    y: 126,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10752_2244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10752_2244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10752_2244",
    x1: 122.659,
    y1: 156.094,
    x2: 122.659,
    y2: 213.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10752_2244",
    x1: 122.659,
    y1: 205.586,
    x2: 122.659,
    y2: 222.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10752_2244",
    x1: 122.659,
    y1: 157.252,
    x2: 122.659,
    y2: 204.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10752_2244",
    x1: 122.659,
    y1: 224.543,
    x2: 122.659,
    y2: 210.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10752_2244",
    x1: 155.673,
    y1: 211.779,
    x2: 155.673,
    y2: 207.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10752_2244",
    x1: 141.298,
    y1: 160.407,
    x2: 141.298,
    y2: 166.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10752_2244",
    x1: 130.134,
    y1: 165.238,
    x2: 130.134,
    y2: 172.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10752_2244",
    x1: 130.146,
    y1: 172.079,
    x2: 130.146,
    y2: 179.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10752_2244",
    x1: 130.134,
    y1: 179.125,
    x2: 130.134,
    y2: 186.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10752_2244",
    x1: 130.134,
    y1: 186.066,
    x2: 130.134,
    y2: 193.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#566AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4953AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10752_2244",
    x1: 106.441,
    y1: 160.618,
    x2: 106.441,
    y2: 166.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10752_2244",
    x1: 95.2766,
    y1: 165.238,
    x2: 95.2766,
    y2: 172.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10752_2244",
    x1: 95.2895,
    y1: 172.079,
    x2: 95.2895,
    y2: 179.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10752_2244",
    x1: 95.2766,
    y1: 179.125,
    x2: 95.2766,
    y2: 186.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10752_2244",
    x1: 138.21,
    y1: 215.611,
    x2: 138.247,
    y2: 228.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10752_2244",
    x1: 133.005,
    y1: 215.581,
    x2: 133.042,
    y2: 228.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10752_2244",
    x1: 133.696,
    y1: 200.808,
    x2: 133.696,
    y2: 219.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10752_2244",
    x1: 178.895,
    y1: 180.3,
    x2: 178.895,
    y2: 189.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10752_2244",
    x1: 177.819,
    y1: 179.143,
    x2: 177.819,
    y2: 191.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10752_2244",
    x1: 158.579,
    y1: 192.172,
    x2: 158.579,
    y2: 219.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10752_2244",
    x1: 149.475,
    y1: 207.673,
    x2: 143.92,
    y2: 199.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10752_2244",
    x1: 132.692,
    y1: 198.24,
    x2: 132.567,
    y2: 240.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10752_2244",
    x1: 182.04,
    y1: 198.213,
    x2: 182.04,
    y2: 240.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10752_2244",
    x1: 162.534,
    y1: 169.929,
    x2: 162.534,
    y2: 206.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10752_2244",
    x1: 169.465,
    y1: 200.529,
    x2: 169.465,
    y2: 193.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10752_2244",
    x1: 171.643,
    y1: 169.93,
    x2: 171.643,
    y2: 206.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10752_2244",
    x1: 169.519,
    y1: 198.215,
    x2: 169.519,
    y2: 240.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10752_2244",
    x1: 169.901,
    y1: 201.12,
    x2: 169.901,
    y2: 190.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10752_2244",
    x1: 154.562,
    y1: 198.214,
    x2: 154.562,
    y2: 240.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10752_2244",
    x1: 170.301,
    y1: 169.93,
    x2: 170.301,
    y2: 206.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10752_2244",
    x1: 169.91,
    y1: 170.646,
    x2: 169.91,
    y2: 181.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10752_2244",
    x1: 160.143,
    y1: 179.115,
    x2: 160.143,
    y2: 191.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10752_2244",
    x1: 159.041,
    y1: 180.3,
    x2: 159.041,
    y2: 189.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10752_2244",
    x1: 181.543,
    y1: 240.509,
    x2: 181.543,
    y2: 195.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10752_2244",
    x1: 183.56,
    y1: 240.509,
    x2: 183.56,
    y2: 195.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3C2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10752_2244",
    x1: 91.4125,
    y1: 218.85,
    x2: 91.4125,
    y2: 227.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10752_2244",
    x1: 89.8486,
    y1: 209.909,
    x2: 89.8486,
    y2: 215.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10752_2244",
    x1: 91.3948,
    y1: 215.606,
    x2: 91.3948,
    y2: 219.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10752_2244",
    x1: 64,
    y1: 156,
    x2: 24.0901,
    y2: 151.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10752_2244",
    x1: 45,
    y1: 102.604,
    x2: 45,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10752_2244"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasShort);
export default __webpack_public_path__ + "static/media/TAS_Short.82778782a7847c13167e8add78257dd3.svg";
export { ForwardRef as ReactComponent };